<template>
  <div>
    <el-menu
      :default-openeds="defaultOpenMenus"
      :default-active="$route.path"
      class="help-menu"
      router>
      <el-submenu index="about">
        <template slot="title">
          <i class="eb-icon-lianxiwomen"/>
          <span>关于我们</span>
        </template>
        <el-menu-item index="/help/about">关于我们</el-menu-item>
      </el-submenu>
      <el-submenu index="process">
        <template slot="title">
          <i class="el-icon-tickets"/>
          <span>订购流程</span>
        </template>
        <el-menu-item index="/help/process">订购流程</el-menu-item>
      </el-submenu>
      <el-submenu index="logistics">
        <template slot="title">
          <i class="eb-icon-wuliu"/>
          <span>配送服务</span>
        </template>
        <el-menu-item index="/help/logistics">配送范围时间</el-menu-item>
        <!-- <el-menu-item index="/help/receipt">订单查询及签收</el-menu-item> -->
      </el-submenu>
      <el-submenu index="payment">
        <template slot="title">
          <i class="eb-icon-zhifufangshi"/>
          <span>支付方式</span>
        </template>
        <el-menu-item index="/help/payment-online">在线支付</el-menu-item>
        <el-menu-item index="/help/payment-offline">网银转账</el-menu-item>
      </el-submenu>
      <el-submenu index="service">
        <template slot="title">
          <i class="eb-icon-shouhou"/>
          <span>售后服务</span>
        </template>
        <el-menu-item index="/help/return">售后政策</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'HelpMenu',
  data() {
    return {
      defaultOpenMenus: ['about', 'process', 'logistics', 'payment', 'service']
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/variables.scss';
.help-menu {
  padding: 30px 0 30px 0;

  /deep/ .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  /deep/ .el-submenu .el-menu-item  {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    min-width: 160px;
  }
  /deep/ .el-menu-item.is-active {
    color: $base-red
  }
}
</style>
